import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Toolbar from '@mui/material/Toolbar';
import { StyledAppBar } from './style';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles'; // Use styled instead of makeStyles
import ProfileMenu from './appBar/ProfileMenu';
import Logo from '../../resources/images/logo-only-color.png';
import { Link } from 'react-router-dom';
import { getPXLDashboardRoute } from '../../router/routes/pxl/factory/general';
import RealmSection from './appBar/RealmSection';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CircularProgress, IconButton } from '@mui/material';
import { Menu } from '@mui/icons-material';
import { hideMenu, setMenu } from '../../store/actions/CommonAction';
import { MENU_MOBILE } from '../../store/reducers/CommonReducer';
import MobileMenu from './drawer/MobileMenu/MobileMenu';

// Use styled API instead of makeStyles
const TitleDiv = styled('div')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'hidden'
}));

const LogoImg = styled('img')(({ theme }) => ({
    marginLeft: '32px',
    marginRight: '32px',
    width: '63px'
}));

const AppBar = () => {
    // Use hooks instead of connect HOC
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const title = useSelector(state => state.common.title);
    const menu = useSelector(state => state.common.menu);
    const ready = useSelector(state => state.common.ready);
    
    // Action creators with dispatch
    const handleSetMenu = (menu) => dispatch(setMenu(menu));
    const handleHideMenu = () => dispatch(hideMenu());
    
    // Other hooks
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('md'));
    
    if (!user) return null; // Use null instead of Fragment
    
    return (
        <StyledAppBar position="absolute" elevation={0}>
            <Toolbar disableGutters>
                <Link to={getPXLDashboardRoute()}>
                    <LogoImg src={Logo} alt="logo" />
                </Link>
                <TitleDiv>
                    <Typography
                        component="span"
                        variant="h6"
                        color="inherit"
                        noWrap
                    >
                        {title}
                    </Typography>
                </TitleDiv>

                <ProfileMenu />
                {!mobile && <RealmSection />}
                {mobile && (
                    <>
                        {ready && (
                            <IconButton 
                                onClick={() => menu ? handleHideMenu() : handleSetMenu(MENU_MOBILE)} 
                                size="large"
                            >
                                <Menu />
                            </IconButton>
                        )}
                        {!ready && <CircularProgress size={18} style={{ marginRight: '6px' }} />}
                        <MobileMenu />
                    </>
                )}
            </Toolbar>
        </StyledAppBar>
    );
};

export default AppBar;
